function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  d: "M322.742 216.096l281.993 10.56M604.735 226.656l84.747-50.987M428.142 172.329l261.34 3.34M322.742 216.096l105.4-43.767M613.47 557.568l-8.735-330.912M330.084 540.076l283.386 17.492M322.742 216.096l7.342 323.98M613.47 557.568l87.313-78.089M689.482 175.669l11.301 303.81"
}));

var _ref3 = /*#__PURE__*/React.createElement("style", null, "\n        .face { font: bold 120px sans-serif; }\n    ");

var _ref4 = /*#__PURE__*/React.createElement("text", {
  x: 445,
  y: 420,
  className: "face"
}, "6");

var SvgD6 = function SvgD6(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "314.905914 164.895447 393.147491 400.311523",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgD6, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/D6.ec22ebaa.svg";
export { ForwardRef as ReactComponent };